import React, { useEffect, useRef, useState } from "react";
import { Field } from "react-final-form";
import { SelectInput } from "../../../components/inputs/final_form/SelectInput";
import { FieldArray } from "react-final-form-arrays";
import { BlankableField } from "../../../components/inputs/final_form/BlankableField";
import { TextInput } from "../../../components/inputs/final_form/TextInput";
import { LoadingButton } from "../../../components/LoadingButton";
import { adminApi as api } from "../../../util/api";
import { required } from "../../../util/validators";
import { AdministrateSelectInput } from "../../components/inputs/AdministrateSelectInput";
import { DENIED_STATUSES } from "../../../util/data/statuses";
import { InputWrapper } from "../../../components/inputs/final_form/InputWrapper";
import { TestSelector } from "../../../components/inputs/final_form/TestSelector";
import { StyledSelect as Select } from "../../../components/inputs/StyledSelect";
import { PayorSelector } from "../../../components/inputs/final_form/PayorSelector";

const getSubstatusOptions = async (status, setSubstatusOptions) => {
  try {
    const { data } = await api.get(`/admin/enums/prior_auth_substatuses.json?status=${status}`);
    setSubstatusOptions(data.resources);
  } catch (err) {
    console.error(err);
  }
};

export const XifinAuthConfigForm = ({ handleSubmit, submitting, edit = true, values, ...rest }) => {
  const [status, setStatus] = useState("");
  const [substatusOptions, setSubstatusOptions] = useState([]);

  const myRef = useRef();

  const handleStatusChange = (selected) => {
    myRef.current?.select?.clearValue();
    setStatus(selected?.value);
  };

  useEffect(() => {
    getSubstatusOptions(status, setSubstatusOptions);
  }, [status]);

  return (
    <>
      <Field component={TextInput} type="hidden" name="id" />
      <Field component={TextInput} type="hidden" name="labId" />
      <Field component={TextInput} required validate={required} label="Auth Number" name="authNumber" />

      <Field
        component={AdministrateSelectInput}
        resourceUrl="/admin/enums/prior_auth_statuses.json"
        label="Status"
        name="status"
        labelKey="label"
        onUpdate={handleStatusChange}
      />

      {substatusOptions?.length >= 1 && (
        <Field
          component={SelectInput}
          label="Substatus"
          name="substatus"
          options={substatusOptions}
          ref={myRef}
          includeBlank
          initialValue={values.substatus}
        />
      )}

      {/** This needs to be a has many selector for this use case and be denial exclusions */}
      {DENIED_STATUSES.includes(values.status) && (
        <Field
          component={AdministrateSelectInput}
          resourceUrl="/admin/enums/denial_reason_options.json"
          valueKey="id"
          label="Denial Code List"
          name="denialCodes"
          labelKey="label"
          isMulti
        />
      )}

      <Field render={PayorSelector} isMulti label="Payor Exclusion List" name="payorExclusions" labelKey="label" />

      <Field name="testExclusions" component={TestSelector} labIds={[values.labId]} label="Test Exclusion List" isMulti data-testid="id" />

      <LoadingButton loading={submitting} onClick={handleSubmit} disabled={submitting}>
        Submit
      </LoadingButton>
    </>
  );
};
